import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import CodeDiff from 'vue-code-diff';
import { changeDetail } from './request';
import topTitle from '@/components/title';
import { insuranceApprove } from './../customerLineManage/request';
import lineInfo from './lineInfo.vue';
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
export default {
  name: 'diff_index',
  components: {
    CodeDiff,
    topTitle,
    lineInfo,
    quillEditor
  },
  data() {
    return {
      quillOption: quillConfig,
      type: this.$route.params.type,
      dataFrom: {
        reviewNodeId: this.$route.params.id
      },
      old_value: "",
      old_value2: "",
      new_value2: "",
      new_value: "",
      context: 1000,
      copywriting: [],
      copywriting2: []
    };
  },
  mounted() {
    if (this.type == 1) {
      changeDetail({
        reviewNodeId: this.$route.params.id
      }).then(res => {
        console.log(res, 9999);
        // this.old_value=JSON.stringify(res.master, null, 4);
        // this.new_value=JSON.stringify(res.unReview, null, 4)
        this.copywriting = res.master.copywriting;
        this.copywriting2 = res.unReview.copywriting;
        this.old_value = this.contFun(res.master);
        this.new_value = this.contFun(res.unReview);
        this.old_value2 = this.contFun2(res.master);
        this.new_value2 = this.contFun2(res.unReview);
      });
    }
  },
  methods: {
    contFun(cont) {
      let val = this.$t('产品名称') + "：" + cont.name.name;
      val += "\n" + this.$t('发布客户') + "：" + cont.customerName;
      val += "\n" + this.$t('客户应用') + "：" + cont.applicationName;
      val += "\n" + this.$t('保险公司') + "：" + cont.unitName;
      val += "\n" + this.$t('险种分类') + "：" + cont.classificationName;
      val += "\n" + this.$t('承保年龄') + "：" + cont.age;
      val += "\n" + this.$t('保障额度') + "：" + cont.amount;
      val += "\n" + this.$t('保障期限') + "：" + cont.duration;
      val += "\n" + this.$t('承保区域') + "：" + cont.area;
      val += "\n" + this.$t('承保职业') + "：" + cont.occupation;
      val += "\n" + this.$t('等待期（天）') + "：" + cont.wait;
      val += "\n" + this.$t('犹豫期（天）') + "：" + cont.hesitate;
      val += "\n" + this.$t('生效日') + "：" + cont.effective;
      val += "\n" + this.$t('支付方式') + "：" + cont.payMethodName;
      val += "\n" + this.$t('出单模式') + "：" + cont.isTimely == 0 ? this.$t('非实时出单') : this.$t('实时出单');
      val += "\n" + this.$t('投保份数') + "：" + cont.servings;
      val += "\n" + this.$t('投保提醒') + "：" + cont.reminder.name;
      // console.log(JSON.stringify(val))
      return val;
    },
    contFun2(cont) {
      let val = this.$t('保险特点') + "：" + cont.feature.name;
      val += "\n" + this.$t('保障权益') + "：";
      cont.rights.map((item, index) => {
        if (index != 0) {
          val += '        ';
        }
        val += item.name + '-' + item.value + '-' + item.info + '\n';
      });
      // if(cont.copywriting){
      //   cont.copywriting.map((item,index)=>{
      //     val+=item.name+'：'+item.content+'\n'
      //   })
      // }
      return val;
    },
    onSubmit(status) {
      if (!this.dataFrom.content) {
        this.$message.error(this.$t('请输入') + this.$t('审核意见'));
        return false;
      }
      this.dataFrom.status = status;
      insuranceApprove(this.dataFrom).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        this.$router.go(-1);
      });
    }
  }
};